import { useContext } from "react";
import { CancelBookingDialogContext } from "./CancelBookingDialogProvider";
import type { CancelBookingDialogState } from "./types";

export const useCancelBookingDialog = (): CancelBookingDialogState => {
  const ctx = useContext(CancelBookingDialogContext);
  if (!ctx) throw new Error("useCancelBookingDialog must be used within a CancelBookingDialogProvider");
  return ctx;
};
